import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadVariations = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/variations/collection`).then((response) => {
            commit(types.ADD_VARIATIONS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateVariation = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/variation', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteVariation = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/'+ data.id +'/variation').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

